import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { SelectedMaterialUUID } from '../../../selectedMaterialsTypes';

import {
  FETCH_SELECTED_MATERIAL_DOWNLOAD_URLS_QUERY,
  FetchSelectedMaterialDownloadUrlsQueryResponse
} from '../../../queries/fetchSelectedMaterialDownloadUrls.query';

import { useSelectedMaterial } from '../../../../selectedMaterials/hooks/useSelectedMaterial';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

import { SelectedMaterialCache } from '../../../SelectedMaterialCache';

interface DownloadSelectedMaterialSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  selectedMaterialUuid: SelectedMaterialUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadSelectedMaterialSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  selectedMaterialUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadSelectedMaterialSeparatelyButtonProps & GADataType) {
  const {
    selectedMaterialLoading,
    refetchSelectedMaterial,
    selectedMaterialError
  } = useSelectedMaterial<FetchSelectedMaterialDownloadUrlsQueryResponse>({
    cacheKey: SelectedMaterialCache.downloadUrls(selectedMaterialUuid),
    options: {
      enabled: false,
      enabledPlaceholder: false
    },
    query: FETCH_SELECTED_MATERIAL_DOWNLOAD_URLS_QUERY,
    uuid: selectedMaterialUuid
  });

  useShowToastOnErrorChange({ error: selectedMaterialError });

  return (
    <DownloadUrlsModalButton<'selectedMaterial'>
      className={className}
      dataGa={dataGa}
      disabled={selectedMaterialLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchSelectedMaterial}
      scope="selectedMaterial"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadSelectedMaterialSeparatelyButton;
